import styled from 'styled-components'

export const Container = styled.ul`
  margin-top: 4px;
`

// FIXME: use some existing font styles here
export const Property = styled.li`
  color: ${o => o.theme.color.stroke.neutral.text.secondary.on.background};
  font-size: 13px;
  font-style: italic;
  line-height: 26px;
`
